export const UserSettings = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="9" r="6" stroke="currentColor" stroke-width="2"/>
<path d="M3 30V25C3 21.6863 5.68629 19 9 19L15 19" stroke="currentColor" stroke-width="2"/>
<path d="M23 16V19" stroke="currentColor" stroke-width="2"/>
<path d="M23 27V30" stroke="currentColor" stroke-width="2"/>
<path d="M27.9497 18.0503L25.8284 20.1716" stroke="currentColor" stroke-width="2"/>
<path d="M20.1716 25.8284L18.0502 27.9497" stroke="currentColor" stroke-width="2"/>
<path d="M30 23L27 23" stroke="currentColor" stroke-width="2"/>
<path d="M19 23L16 23" stroke="currentColor" stroke-width="2"/>
<path d="M27.9497 27.9497L25.8284 25.8284" stroke="currentColor" stroke-width="2"/>
<path d="M20.1716 20.1716L18.0502 18.0503" stroke="currentColor" stroke-width="2"/>
<circle cx="23" cy="23" r="4" stroke="currentColor" stroke-width="2"/>
</svg>`;
